import { render } from "./SaleView.vue?vue&type=template&id=4b7c7702&ts=true"
import script from "./SaleView.vue?vue&type=script&lang=ts"
export * from "./SaleView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__